import { ChangeEvent, useEffect, useState } from "react";
import { getFileIcon } from "../../common";
import { MAX_FILE_SIZE } from "../../constant";
import InputArea from "../InputArea";
import ToolTip from "../ToolTip";
interface CommentBoxProps {
    onComment: (payload: { comment: string; file: File | null, parentCommentId?: number | null }) => void;
    type?: 'comment' | 'reply';
    onGetParentCommentId?: number | null;
    onReset?: boolean;
}
export default function CommentBox(props: CommentBoxProps) {
    const { onComment, type, onGetParentCommentId, onReset = false } = props;
    const [comment, setComment] = useState<string>("");
    const [file, setFile] = useState<File | null>(null);

    useEffect(() => {
        if (onReset) {
            setComment("");
            setFile(null);
        }
    }, [onReset]);

    const handleSubmitComment = () => {
        // console.log("type", type);
        // console.log("onGetParentCommentId", onGetParentCommentId);
        if (type === "reply" && onGetParentCommentId) {
            onComment({ comment, file, parentCommentId: onGetParentCommentId });
        } else {
            onComment({ comment, file });
        }
    }

    const handleGetText = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setComment(e.target.value);
    }

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0];
        if (!selectedFile) return;

        if (selectedFile.size > MAX_FILE_SIZE) {
            setFile(null);
            return;
        }
        setFile(selectedFile);
    };
    return (
        <div className={`${type === "reply" ? "w-[80%]" : "w-full"}`}>
            <div className="relative">
                <div className="relative">
                    <InputArea
                        value={comment}
                        onChange={handleGetText}
                        label={type === "reply" ? "" : "Thảo luận về bài học"}
                        name="comment"
                        placeholder={`${type === "reply" ? "" : "Tham gia thảo luận ..."}`}
                        styleLabel="text-[19px] font-bold"
                        styleArea="mt-[20px] text-[14px] pr-[50px]"
                    />

                    <div
                        className={` group
                        absolute right-[12px] ${type === "reply" ? "top-[70%]" : "top-[75%]"} -translate-y-1/2
                        text-[26px]
                        ${comment || file ? "cursor-pointer text-secondary" : "text-gray-300"}
                    `}
                        onClick={comment || file ? handleSubmitComment : undefined}
                    >
                        <i className={`fa-solid fa-paper-plane rotate-plane ${type === "reply" ? "text-[20px]" : "text-[30px]"}`}></i>

                        {!comment && !file && (
                            <ToolTip text="Gửi bình luận hoặc file" />
                        )}
                    </div>
                </div>

                <div className="absolute bottom-[-20px] left-[10px]">
                    {file && (
                        <>
                            {getFileIcon(file.name, true)}
                            <i
                                className="fa-solid fa-xmark text-red-500 cursor-pointer absolute top-[-10px] right-[-26px] hover:bg-gray-100 rounded-full py-[4px] px-[6px]"
                                onClick={(e) => {
                                    e.preventDefault(); // ngăn default action của label
                                    e.stopPropagation(); // ngăn bubble lên label
                                    setFile(null);
                                }}
                            ></i>
                        </>
                    )}
                </div>
                <label className="flex justify-center items-center w-[20px] h-[20px] cursor-pointer absolute bottom-[30px] left-[10px] group">
                    <input
                        type="file"
                        className="hidden"
                        onChange={handleFileChange}
                    />
                    {/* <label className="font-[600] inline-block mb-[6px]">Chọn file</label> */}
                    {!file && (
                        <div className="text-center">
                            <i className={`fa-solid fa-file ${type === "reply" ? "text-[20px]" : "text-[30px]"} text-blue-500 mb-[10px]`}></i>
                        </div>
                    )}
                    {!file && <ToolTip text="Đính kèm một ảnh hoặc file" />}
                </label>
                {/* <Button onClick={() => handleSubmitComment()}
                label="Gửi bình luận" styleButton="w-[158px] h-[45px] mt-[30px]" /> */}

            </div>
        </div >
    )
}